module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Maja_480x480.49fc0fa0.mp4";